// Pre-start questionnaire — for owners who haven't launched yet.
// Each tag maps to a pre-start service in scopeEngine.js

export const PRESTART_CATEGORIES = [
  {
    id: "concept",
    label: "Business Concept",
    intro: "How clearly defined is your business idea today?",
    questions: [
      {
        id: "ps_concept",
        type: "choice",
        prompt: "Which best describes where your idea is right now?",
        options: [
          { value: "early", label: "Early idea — still exploring", weight: 3, tags: ["concept_unclear"] },
          { value: "shaping", label: "Taking shape — testing the thinking", weight: 2, tags: ["concept_unclear"] },
          { value: "clear", label: "Clear concept, ready to act on", weight: 0 },
        ],
      },
      {
        id: "ps_problem",
        type: "yesno",
        prompt: "Have you clearly defined the customer problem you're solving?",
        noTags: ["concept_unclear"],
        noWeight: 2,
      },
    ],
  },
  {
    id: "market",
    label: "Market & Customer",
    intro: "How well do you understand your customer and market?",
    questions: [
      {
        id: "ps_customer",
        type: "yesno",
        prompt: "Have you spoken to potential customers to validate demand?",
        noTags: ["market_unknown"],
        noWeight: 3,
      },
      {
        id: "ps_competitors",
        type: "yesno",
        prompt: "Do you know who your main competitors are and how you'll differentiate?",
        noTags: ["market_unknown"],
        noWeight: 2,
      },
    ],
  },
  {
    id: "financial_plan",
    label: "Startup Costs",
    intro: "How much have you mapped out the cost of getting started?",
    questions: [
      {
        id: "ps_costs",
        type: "choice",
        prompt: "Have you estimated your startup costs?",
        options: [
          { value: "no", label: "No, not yet", weight: 3, tags: ["no_startup_costs"] },
          { value: "rough", label: "A rough idea only", weight: 2, tags: ["no_startup_costs"] },
          { value: "detailed", label: "Yes, detailed estimate", weight: 0 },
        ],
      },
      {
        id: "ps_runway",
        type: "yesno",
        prompt: "Do you know how much cash you'll need to reach break-even?",
        noTags: ["no_startup_costs"],
        noWeight: 2,
      },
    ],
  },
  {
    id: "pricing_setup",
    label: "Pricing Approach",
    intro: "Have you thought through how you'll price your offer?",
    questions: [
      {
        id: "ps_pricing",
        type: "choice",
        prompt: "How would you describe your pricing thinking right now?",
        options: [
          { value: "none", label: "Haven't thought about it yet", weight: 3, tags: ["startup_pricing"] },
          { value: "match", label: "Plan to match competitors", weight: 2, tags: ["startup_pricing"] },
          { value: "modelled", label: "Pricing modelled around costs & value", weight: 0 },
        ],
      },
    ],
  },
  {
    id: "funding_setup",
    label: "Funding",
    intro: "How will you fund the launch and early months?",
    questions: [
      {
        id: "ps_funding_source",
        type: "choice",
        prompt: "What is your primary source of startup capital?",
        options: [
          { value: "savings", label: "Personal savings", weight: 1 },
          { value: "loan", label: "Plan to apply for a loan or finance", weight: 3, tags: ["startup_funding_need"] },
          { value: "investor", label: "Seeking investors / equity partners", weight: 3, tags: ["startup_funding_need"] },
          { value: "unsure", label: "Not sure yet", weight: 3, tags: ["startup_funding_need", "concept_unclear"] },
        ],
      },
      {
        id: "ps_forecasts",
        type: "yesno",
        prompt: "Do you have financial forecasts (P&L, cash flow) for the first 3 years?",
        noTags: ["no_startup_forecasts"],
        noWeight: 3,
      },
    ],
  },
  {
    id: "business_plan",
    label: "Business Plan",
    intro: "How much of your strategy is written down today?",
    questions: [
      {
        id: "ps_plan",
        type: "choice",
        prompt: "Do you currently have a written business plan?",
        options: [
          { value: "no", label: "No plan written yet", weight: 3, tags: ["no_business_plan"] },
          { value: "draft", label: "A rough draft only", weight: 2, tags: ["no_business_plan"] },
          { value: "complete", label: "Yes, a complete business plan", weight: 0 },
        ],
      },
    ],
  },
  {
    id: "setup",
    label: "Structure & Setup",
    intro: "How clear are you on the legal and operational setup?",
    questions: [
      {
        id: "ps_structure",
        type: "yesno",
        prompt: "Have you decided on the business structure (e.g. sole trader, company, trust)?",
        noTags: ["setup_help"],
        noWeight: 2,
      },
      {
        id: "ps_registrations",
        type: "yesno",
        prompt: "Are you clear on registrations needed (ABN, GST, licences)?",
        noTags: ["setup_help"],
        noWeight: 2,
      },
      {
        id: "ps_software",
        type: "yesno",
        prompt: "Have you chosen accounting/bookkeeping software for day one?",
        noTags: ["setup_help"],
        noWeight: 1,
      },
    ],
  },
  {
    id: "literacy",
    label: "Financial Confidence",
    intro: "How confident do you feel about the financial side of running a business?",
    questions: [
      {
        id: "ps_confidence",
        type: "slider",
        prompt: "How confident are you reading financial reports and managing the numbers?",
        min: 1, max: 10, step: 1,
        lowLabel: "Not confident", highLabel: "Very confident",
        scoreInverse: true, weight: 0.4, tag: "low_confidence_startup",
      },
    ],
  },
  {
    id: "mentoring",
    label: "Mentoring",
    intro: "Where will you turn when you need to talk through big decisions?",
    questions: [
      {
        id: "ps_mentor",
        type: "yesno",
        prompt: "Would you value a trusted advisor to guide you through the launch and first year?",
        yesTags: ["startup_mentoring"],
        yesWeight: 2,
      },
      {
        id: "ps_biggest",
        type: "text",
        prompt: "In a sentence — what's the biggest question you're trying to answer right now?",
        placeholder: "e.g. How do I price this without underselling myself?",
        optional: true,
      },
    ],
  },
];
